import {IAppError} from "@pg-mono/request-state";

/**
 * Marker set on an error that was already reported to Amplitude as `lead_form_error` by the lead send
 * pipeline (`sendLead`), so error handlers up the call stack don't report the same failure a second time.
 */
const AMPLITUDE_ERROR_TRACKED_KEY = "isAmplitudeLeadFormErrorTracked";

export const markLeadFormSubmitErrorTracked = <TError>(error: TError): TError => {
    if (typeof error === "object" && error !== null) {
        Object.assign(error, {[AMPLITUDE_ERROR_TRACKED_KEY]: true});
    }

    return error;
};

export const isLeadFormSubmitErrorTracked = (error: unknown): boolean =>
    typeof error === "object" && error !== null && (error as Record<string, unknown>)[AMPLITUDE_ERROR_TRACKED_KEY] === true;

/** Shape thrown by `handlePostApplicationResponse` / RTK application errors consumed in lead forms. */
export const isLeadFormSubmitAppError = (error: unknown): error is {appError: IAppError} => {
    if (typeof error !== "object" || error === null || !("appError" in error)) {
        return false;
    }

    const {appError} = error as {appError: unknown};

    return (
        typeof appError === "object" &&
        appError !== null &&
        "status" in appError &&
        typeof (appError as IAppError).status === "number" &&
        "fieldErrors" in appError &&
        typeof (appError as IAppError).fieldErrors === "object" &&
        (appError as IAppError).fieldErrors !== null &&
        "nonFieldErrors" in appError &&
        Array.isArray((appError as IAppError).nonFieldErrors)
    );
};
import {IAppError} from "@pg-mono/request-state";

/**
 * Marker set on an error that was already reported to Amplitude as `lead_form_error` by the lead send
 * pipeline (`sendLead`), so error handlers up the call stack don't report the same failure a second time.
 */
const AMPLITUDE_ERROR_TRACKED_KEY = "isAmplitudeLeadFormErrorTracked";

export const markLeadFormSubmitErrorTracked = <TError>(error: TError): TError => {
    if (typeof error === "object" && error !== null) {
        Object.assign(error, {[AMPLITUDE_ERROR_TRACKED_KEY]: true});
    }

    return error;
};

export const isLeadFormSubmitErrorTracked = (error: unknown): boolean =>
    typeof error === "object" && error !== null && (error as Record<string, unknown>)[AMPLITUDE_ERROR_TRACKED_KEY] === true;

/** Shape thrown by `handlePostApplicationResponse` / RTK application errors consumed in lead forms. */
export const isLeadFormSubmitAppError = (error: unknown): error is {appError: IAppError} => {
    if (typeof error !== "object" || error === null || !("appError" in error)) {
        return false;
    }

    const {appError} = error as {appError: unknown};

    return (
        typeof appError === "object" &&
        appError !== null &&
        "status" in appError &&
        typeof (appError as IAppError).status === "number" &&
        "fieldErrors" in appError &&
        typeof (appError as IAppError).fieldErrors === "object" &&
        (appError as IAppError).fieldErrors !== null &&
        "nonFieldErrors" in appError &&
        Array.isArray((appError as IAppError).nonFieldErrors)
    );
};
